import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: ReactNode;
  delay?: number;
  className?: string;
};
export function Reveal({
  children,
  delay = 0,
  className
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-128" data-mp="3bixe8dvtm5pf">
      {children}
    </motion.div>;
}